import React from 'react'
import styled from '@emotion/styled'
import { SUI } from 'shared/ui'
import Controller from './Controller'

const content = React.forwardRef(
  ({ className, style, hideModal, ...rest }, forwardedRef) => {
    return (
      <SUI>
        <div className={className} style={style} ref={forwardedRef}>
          <div className="box">
            <Controller hideModal={hideModal} {...rest} />
          </div>
        </div>
      </SUI>
    )
  }
)

const Content = styled(content)`
  display: flex;
  min-height: 100%;
  height: 100%;
  background: white;

  /**
   * Safari 10 doesn't calculate height of flex children correctly, so we need
   * to set height explicitly for children to use it as basis
   * https://bugs.webkit.org/show_bug.cgi?id=137730
   */
  .safari10 & {
    height: 430px;
  }

  .box {
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: space-between;
    overflow: hidden;
    width: 320px;
    z-index: 100;
  }
`

export default Content
